import type { ProjectOption } from "./onboarding";

export async function parseJson<T>(response: Response): Promise<T> {
  const data = await response.json();
  if (!response.ok) {
    const message = typeof data?.error === "string" ? data.error : "Request failed";
    throw new Error(message);
  }
  return data as T;
}

export function normalizeProjectOptions(input: unknown): ProjectOption[] {
  if (!Array.isArray(input)) return [];
  return input.flatMap((entry): ProjectOption[] => {
    if (typeof entry === "string") {
      const id = entry.trim();
      return id ? [{ id, name: id }] : [];
    }

    if (!entry || typeof entry !== "object") return [];
    const id = typeof entry.id === "string" ? entry.id.trim() : "";
    if (!id) return [];
    const name = typeof entry.name === "string" && entry.name.trim() ? entry.name.trim() : id;
    return [{ id, name }];
  });
}
